<template>
  <div class="paper-style-dialog">
    <el-dialog class="common-dialog" title="报纸样式" :visible.sync="visible" center :modal-append-to-body="false" :close-on-click-modal="false">
      <span class="paper-style-dialog__title">请选择报纸样式</span>
      <el-select v-model="selectedStyle">
        <el-option v-for="item in options" :value="item.value" :key="item.value" :label="item.label"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="clickCancel" size="small">取 消</el-button>
        <el-button type="primary" @click="clickConfirm" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@api/getBook'

export default {
  name: 'PaperStyleDialog',
  data() {
    return {
      visible: false,
      selectedStyle: 0,
      paperData: {},
      options: [
        {
          value: 1,
          label: '传统样式'
        },
        {
          value: 0,
          label: '翻页样式'
        }
      ]
    }
  },
  methods: {
    clickCancel() {
      this.visible = false
    },
    clickConfirm() {
      const params = {
        id: this.paperData.id,
        style: this.selectedStyle
      }
      apis.modifyBaoZhiStyle(params).then((res) => {
        let { status } = res.data
        if (status == 0) {
          this.$parent.getManagerList()
        }
      })
      this.clickCancel()
    },
    open(item) {
      this.paperData = item
      this.selectedStyle = item.style || 0
      this.visible = true
    }
  }
}
</script>

<style scoped lang="scss">
.paper-style-dialog {
  &__title {
    margin-right: 10px;
  }
}
</style>
